<div>
  <mat-form-field class="w-full">
    <mat-label>Search Package Library</mat-label>
    <input matInput [formControl]="searchControl">
    @if (searchActive$ | async) {
      <app-icon matIconSuffix class="mr-2" icon="spinner" [spin]="true"></app-icon>
    }
    <mat-hint>{{ packagingTypeDisplay$ | async }}</mat-hint>
  </mat-form-field>
  <mat-action-list>
    <button mat-list-item (click)="newPackage()" i18n>Add Empty Package</button>
    @for (pkg of filteredPackages$ | async; track pkg) {
      <button mat-list-item (click)="selectPackage(pkg)">
        <app-icon icon="package-library"></app-icon>
        {{ pkg.description }}
      </button>
    }
  </mat-action-list>
</div>